export const setActiveFeature = activeFeature => ({
    type: "ACTIVE_FEATURE:SET",
    payload: activeFeature,
});
export const setSearchBarVisible = isVisible => ({
    type: "SEARCH_BAR_VISIBLE:SET",
    payload: isVisible,
});
export const setSearchedLocation = latLng => ({
    type: "SEARCHED_LOCATION:SET",
    payload: latLng,
});
export const setActiveProject = x => ({
    type: "ACTIVE_PROJECT:SET",
    payload: x,
});
export const setActiveFilter = hub => ({
    type: "ACTIVE_FILTER:SET",
    payload: hub,
});
export const setBasemap = imagery => ({
    type: "MAP:SET_BASEMAP",
    payload: imagery,
});
export const setActivePage = page => ({
    type: "ACTIVE_PAGE:SET",
    payload: page,
});
export const setMapType = mapType => ({
    type: "MAP_TYPE:SET",
    payload: mapType,
});
export const setZoomToNsw = x => ({
    type: "ZOOM_TO_NSW",
    payload: x,
});



// WEBPACK FOOTER //
// ./src/actions/ui.js